import { AssetType } from '@shared/models/entities/asset/assetType';
import { Mime } from '@shared/models/entities/asset/mimeType';

export abstract class SaveStoryAssetDto {
    constructor(public mimeType: Mime,
        public assetType: AssetType,
        public name: string,
        public storyId: number) {
    }
}